<script>
export default {
  name: "signal-r",
  data: function() {
    return {};
  },
  methods: {
    initializeSignalR: function() {
      var self = this;
      ("use strict");
      var url = `${process.env.VUE_APP_ROOT_URL}/messageHub`;
      self.connection = new signalR.HubConnectionBuilder()
        .withUrl(url)
        .configureLogging(signalR.LogLevel.Information)
        .build();
      self.startConnection();

      // re-establish the connection if connection dropped
      self.connection.onclose(function() {
        setTimeout(self.startConnection(), 5000);
      });

      //refresh chat messages
      self.connection.on(`refresh_${this.auctionId}`, function(userId, bidId) {
        if (userId != self.currentUserId) {
          self.$emit("refreshChatLog");
        }
      });

      //refresh bid chat message
      self.connection.on(`refresh_bid_${this.auctionId}`, function(userId, bidId) {
        self.$emit("refreshChatLog", bidId, userId);
        self.$emit("refreshBidList");
      });
      //refresh bid amount
      self.connection.on(`refresh_bid_amount_${this.auctionId}`, function() {
        self.$emit("refreshChatLog");
        self.$emit("refreshBidList");
      });

      //on Auction Stop/Start/Extend
      self.connection.on(`auction_${this.auctionId}_action`, function(action) {
        if (action == "start") {
          self.$emit("onAuctionStart");
        } else if (action == "stop") {
          self.$emit("onAuctionStop");
          if (self.isOwner) {
            self.$store.commit("setMessage", {
              title: "End of Auction",
              type: "error",
              content: `Thank you for participating in this auction.<br/><br/> Please be advised that the outcome of this auction is not legally binding. The auction host reserves the right to determine post-auction which vessel or vessels are suitable based not only on the auction outcome but also any additional criteria they deem relevent.`,
              html: true,
            });
          }
        } else if (action == "e30") {
          self.$emit("onAuctionExtend", 30);
        } else if (action == "e120") {
          self.$emit("onAuctionExtend", 120);
        }
      });

      //refresh active bidders
      if (self.isInternal || self.isCharterer) {
        self.connection.on(`auction_${this.auctionId}_activeBidders`, function() {
          self.$emit("refreshBidList");
        });
      }

      //on vessel withdrawn
      self.connection.on(`auction_${this.auctionId}_vesselWithdrawn`, function() {
        self.$emit("refreshBidList");
      });

      //on multi-vessel offer
      self.connection.on(`auction_${this.auctionId}_mv`, function() {
        self.$emit("refreshBidList");
        self.$emit("refreshChatLog");
      });
    },
    startConnection: function() {
      this.connection.start().then(function() {
        console.log("connected");
      });
    },
  },
  computed: {
    currentUserId: function() {
      return this.$store.state.userId;
    },
    auctionId: function() {
      return this.$store.state.activeAuction.id;
    },
    userRole: function() {
      return this.$store.state.role;
    },
    isCharterer: function() {
      return this.userRole == "CHA";
    },
    isOwner: function() {
      return this.userRole == "OWN";
    },
    isInternal: function() {
      return this.userRole == "SHP" || this.userRole == "ADM" || this.userRole == "ALY";
    },
  },
  mounted: function() {
    this.initializeSignalR();
  },
};
</script>
<template>
  <div></div>
</template>
